import { render, staticRenderFns } from "./NewOrEdit.vue?vue&type=template&id=4f345ebc&"
import script from "./NewOrEdit.vue?vue&type=script&lang=js&"
export * from "./NewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports